<template>
  <ValidationObserver ref="scopeForm" tag="fieldset" v-slot="{ invalid }">
    <b-form @submit.prevent>
    <b-row>
      <b-col>
        <distribution-form-group
          :label="$t('type') | capitalize"
          label-cols="2"
          vid="college"
          ref="college"
          rules="required"
          v-slot="{ state }"
          :hide-feedback="payoutMode === payoutModes.VIEW"
          >
          <b-col v-if="payoutMode === payoutModes.VIEW" class="view-values" cols="10"> {{ collegeText(payoutData.scope.college) }} </b-col>
          <b-form-select v-else required v-model="payoutData.scope.college" :options="collegeOptions" :state="state">
          </b-form-select>
          <fa-icon v-if="payoutMode === payoutModes.EDIT" :icon="['fa', 'pen']" class="ml-1 edit-svg"/>
        </distribution-form-group>
      </b-col>
    </b-row>
    <!-- Collective/society -->
    <b-row class="mt-2">
      <b-col>
        <distribution-form-group
          :label="$t('collective_society')"
          label-cols="2"
          vid="collectiveSociety"
          ref="collectiveSociety"
          :rules="selectedSociety.except !=='all'? 'required' : ''"
          v-slot="{ state }"
          :hide-feedback="payoutMode === payoutModes.VIEW"
        >
        <b-col v-if="payoutMode === payoutModes.VIEW" class="view-values d-flex" cols="10">
          <div class="select">
            <span>{{ payoutData.scope.societies.select | capitalize }}</span>
          </div>
           <div class="values">
            <span>{{ societyText(payoutData.scope.societies.ids) }}</span>
           </div>
        </b-col>
        <b-input-group v-else class="include-exclude-append">
          <template v-slot:append>
            <include-exclude-selector
              :options="memberCollectiveOptions"
              :except-string="$t('all_except') | capitalize"
              :include-string="$t('include_specific') | capitalize"
              :placeholder="getPlaceholder('selectedSociety')"
              label=""
              label-cols="0"
              v-model="selectedSociety"
              :enable-all="true"
              selectorCols="col-3 pr-0"
            />
          </template>
          <b-form-select required v-model="selectedSociety.values" :options="[]" :state="state" :disabled="true" :hidden="true"/>
        </b-input-group>
        <fa-icon v-if="payoutMode === payoutModes.EDIT" :icon="['fa', 'pen']" class="ml-1 edit-svg"/>
        </distribution-form-group>
      </b-col>
    </b-row>
    <!-- Copyrights -->
    <b-row class="mt-2">
      <b-col>
        <distribution-form-group
          :label="$t('copyrights') | capitalize"
          label-cols="2"
          vid="copyrights"
          ref="copyrights"
          :rules="copyrightsRule()"
          v-slot="{ state }"
          :disabled="selectedSociety.except === 'all'"
          :hide-feedback="payoutMode === payoutModes.VIEW"
        >
        <b-col v-if="payoutMode === payoutModes.VIEW" class="view-values d-flex" cols="10">
          <div class="select">
            <span>{{ payoutData.scope.copyrights.select | capitalize }}</span>
          </div>
           <div class="values">
            <span>{{ copyrightsText(payoutData.scope.copyrights.codes) }}</span>
           </div>
        </b-col>
        <b-input-group v-else class="include-exclude-append">
          <template v-slot:append>
            <include-exclude-selector
              :options="copyrightsOptions"
              :except-string="$t('all_except') | capitalize"
              :include-string="$t('include_specific') | capitalize"
              :placeholder="getPlaceholder('selectedCopyrights')"
              label=""
              label-cols="0"
              v-model="selectedCopyrights"
              :enable-all="true"
              selectorCols="col-3 pr-0"
            />
          </template>
          <b-form-select required v-model="selectedCopyrights.values" :options="[]" :state="state" :disabled="true" :hidden="true" />
        </b-input-group>
        <fa-icon v-if="payoutMode === payoutModes.EDIT" :icon="['fa', 'pen']" class="ml-1 edit-svg"/>
        </distribution-form-group>
      </b-col>
    </b-row>
    <!-- tariff periods -->
    <b-row class="mt-2"> 
      <b-col>
        <distribution-form-group
          :label="$t('tariff_periods') | capitalize"
          label-cols="2"
          vid="tariffPeriods"
          ref="tariffPeriods"
          :rules="selectedDistribution.except !=='all'? 'required' : ''"
          v-slot="{ state }"
          :hide-feedback="payoutMode === payoutModes.VIEW"
        >
          <b-col v-if="payoutMode === payoutModes.VIEW" class="view-values d-flex" cols="10">
            <div class="select">
              <span>{{ payoutData.scope.distributions.select | capitalize }}</span>
            </div>
            <div class="values">
              <NamesListModal class-names="mb-2" :values="mapTariffs(payoutData.distributionsMap)" modalTitle="tariff periods"/>
            </div>
          </b-col>
          <b-input-group v-else class="custom-select-search">
            <template v-slot:append>
              <b-form-select class="col-3" v-model="selectedDistribution.except">
                <b-form-select-option value="all">{{ $t("all") | capitalize }}</b-form-select-option>
                <b-form-select-option :value="false">{{ $t('include_specific') | capitalize }}</b-form-select-option>
                <b-form-select-option :value="true">{{ $t('all_except') | capitalize }}</b-form-select-option>
              </b-form-select>

              <multi-select 
                v-model="selectedDistribution.values" 
                id="tariffPeriodsMultiSearch" 
                label="name" 
                track-by="value" 
                :placeholder="getPlaceholder('selectedDistribution')" 
                :options="tariffPeriodOptions" 
                :multiple="true" 
                :searchable="true" 
                :loading="isLoading" 
                :close-on-select="false" 
                :show-no-results="true" 
                @search-change="findTariffOptions"
                :disabled="selectedDistribution.except === 'all'"
              >
                <template #option="props">
                  <div class="option__desc">
                    <span class="option__small">{{ props.option.name }}</span>
                    <p class="option__title" v-if="props.option.warning">Warning: Amount balance is bellow moratorium minimum!</p>
                  </div>
                </template>
              </multi-select>
            </template>
            <b-form-select required v-model="selectedDistribution.values" :options="[]" :state="state" :disabled="true" :hidden="true" />
          </b-input-group>
          <fa-icon v-if="payoutMode === payoutModes.EDIT" :icon="['fa', 'pen']" class="ml-1 edit-svg"/>
        </distribution-form-group>
      </b-col>
    </b-row>
    <!-- closeout -->
    <b-row class="mt-2">
      <b-col>
        <distribution-form-group
          :label="$t('include_closeouts') | capitalize"
          label-cols="2"
          vid="closeouts"
          ref="closeouts"
          rules="required"
          v-slot="{ state }"
          :hide-feedback="payoutMode === payoutModes.VIEW"
        >
          <b-col v-if="payoutMode === payoutModes.VIEW" class="view-values" cols="10"> {{ payoutData.scope.includeCloseoutTransactions ? "Yes" : "No" }} </b-col>
          <b-form-select v-else required v-model="payoutData.scope.includeCloseoutTransactions" :options="closeoutsOptions" :state="state" />
          <fa-icon v-if="payoutMode === payoutModes.EDIT" :icon="['fa', 'pen']" class="ml-1 edit-svg"/>
        </distribution-form-group>
      </b-col>
    </b-row>
    <!-- threshold -->
    <b-row class="mt-2">
      <b-col>
        <distribution-form-group
          :label="$t('min_threshold') | capitalize"
          label-cols="2"
          vid="threshold"
          ref="threshold"
          v-slot="{ state }"
          :hide-feedback="payoutMode === payoutModes.VIEW"
        >
          <b-col v-if="payoutMode === payoutModes.VIEW" class="view-values" cols="10"> {{ "$" + payoutData.scope.minThreshold }} </b-col>
          <b-form-input v-else v-model="payoutData.scope.minThreshold" :state="state"/>
          <fa-icon v-if="payoutMode === payoutModes.EDIT" :icon="['fa', 'pen']" class="ml-1 edit-svg"/>
        </distribution-form-group>
      </b-col>
    </b-row>
    <div class="fixed-footer">
      <div class="d-flex justify-content-end">
        <b-button
          class="ml-3 mr-3 btn-outline-red"
          type="submit"
          :disabled="invalid"
          v-if="payoutMode === payoutModes.CREATE"
          @click="onSubmit"
        >
          {{ $t("set_scope") | capitalize }}
        </b-button>

        <b-button v-if="payoutMode === payoutModes.VIEW && canEdit" class="btn-outline-red" @click="editForm">{{ $t("modify_scope") | capitalize }}</b-button>
        <b-button v-if="payoutMode === payoutModes.EDIT" class="btn-outline-dark mr-3" @click="cancel">{{ $t("cancel") | capitalize }}</b-button>
        <b-button v-if="payoutMode === payoutModes.EDIT" class="btn-outline-red" :disabled="invalid" @click="onSubmit">
          {{ $t("save_changes") | capitalize }}
        </b-button>

        <b-button 
        class="btn-outline-red ml-3 mr-3"
        :disabled="payoutMode === payoutModes.EDIT || payoutData.status === payoutStatuses.IN_REVIEW"
        v-if="payoutMode !== payoutModes.CREATE"
        @click="handleLoadTransactions"
        >
          {{ $t("load_transactions") | startcase }}
        </b-button>
      </div>
    </div>
    </b-form>
    <modal
      id="confirmation-modal"
      :customTitle="$t('modify_scope') | capitalize"
      modal-class="custom-modal info"
      modalType="edit"
      size="lg"
      @ok="onSubmit(false)"
      centered
      :okTitle="$t('confirm') | capitalize"
    >
      <template v-if="scopeMessage && scopeMessage.belowMoratoriumDistributions.length">
        <p>Following distributions with amount balance below moratorium minimum will be added to the Payout:</p>
        <ul>
          <li v-for="distribution in scopeMessage.belowMoratoriumDistributions" :key="distribution">{{ distribution }}</li>
        </ul>
      </template>

      <template v-if="scopeMessage &&scopeMessage.lowBalanceDistributions.length">
        <p>Following distributions with amount balance below payable amount will be excluded from the Payout:</p>
        <ul>
          <li v-for="distribution in scopeMessage.lowBalanceDistributions" :key="distribution">{{ distribution }}</li>
        </ul>
      </template>

      <template v-if="scopeMessage &&scopeMessage.moratoriumDistributions.length">
        <p>Following distributions with active moratorium flag will be excluded from the Payout:</p>
        <ul>
          <li v-for="distribution in scopeMessage.moratoriumDistributions" :key="distribution">{{ distribution }}</li>
        </ul>
      </template>
    </modal>
  </ValidationObserver>
</template>
<script>

import { distributionCollegeTypes, payoutModes, payoutStatuses } from "@/constants"
import { mapActions, mapState } from "vuex"
import DistributionFormGroup from "@/components/DistributionFormGroup"
import NamesListModal from "@/pages/Repertoire/Recordings/NamesListModal"
import { ValidationObserver } from "vee-validate"
import { capitalize } from "lodash"

export default {
  name: "ScopeSection",
  components: { DistributionFormGroup, ValidationObserver, NamesListModal },
  props: {
    payoutData: {
      type: Object,
    },
    payoutMode: String,
    canEdit: Boolean,
    selectedSociety: Object,
    selectedDistribution: Object,
    selectedCopyrights: Object,
  },
  computed: {
    ...mapState("consts", ["copyrights","memberCollectives","tariffs"]),
    memberCollectiveOptions () {
      return this.memberCollectives.map(x => ({ name: x.name, value: x.name }))
    },
    copyrightsOptions () {
      return this.copyrights.map(c => ({ name: c.text, value: c.code }))
    },
  },
  data () {
    return {
      scopeMessage: null,
      collegeOptions: [
        { value: "maker", text: capitalize(this.$t("maker")) },
        { value: "performer", text: capitalize(this.$t("performer")) },
        { value: "maker_and_performer", text: capitalize(this.$t("maker_and_performer")) }
      ],
      closeoutsOptions: [
        { value: "true", text: capitalize("yes") },
        { value: "false", text: capitalize("no") }
      ],
      isLoading: false,
      payoutModes,
      payoutStatuses,
      tariffPeriodOptions: [],
    }
  },

  methods: {
    ...mapActions("consts", ["getCopyrights", "getTariffs"]),
    ...mapActions("alert", ["success", "error"]),

    editForm () {
      this.$emit("change-payout-mode", payoutModes.EDIT)
      this.selectedSociety.except = this.getSelectValue(this.payoutData.scope.societies.select)
      this.selectedSociety.values = this.generateSocietyOptions()
      this.selectedCopyrights.except = this.getSelectValue(this.payoutData.scope.copyrights.select)
      this.selectedCopyrights.values = this.generateCopyrightOptions()
      this.selectedDistribution.except = this.getSelectValue(this.payoutData.scope.distributions.select)
      this.selectedDistribution.values = this.generateTariffOptions()
    },
    cancel () {
      this.$emit("reset")
    },
    handleLoadTransactions () {
      this.$api.payouts.applyPayout(this.payoutData.id).then(() => {
        this.success("Payout transactions are being loaded. Please wait.")
      }).catch(() => {
        this.error("Failed to load transactions. Please contact administrator or try again.")
      })
    },
    collegeText (value) {
      return this.collegeOptions.find(item => item.value === value)?.text || ""
    },
    societyText (values) {
      if (Array.isArray(values)) {
        return values.join(", ")
      }
      return ""
    },
    copyrightsText (values) { 
      if (Array.isArray(values)) {
        return values
          .map(value =>
            this.copyrightsOptions.find(item => item.value === value)?.name || ""
          ).join(", ")
      }
      return ""
    },
    mapTariffs (tariffObj) {
      return tariffObj ? Object.values(tariffObj).map(item => item.description) : []
    },

    isBelowMoratorium (distribution) {
      if (this.payoutData.scope.college === distributionCollegeTypes.MAKER) {
        return distribution.isMoratoriumAlertMaker
      } else if (this.payoutData.scope.college === distributionCollegeTypes.PERFORMER) {
        return distribution.isMoratoriumAlertPerformer
      } else {
        return distribution.isMoratoriumAlertMaker || distribution.isMoratoriumAlertPerformer
      }
    },

    generateSocietyOptions () {
      const societyIds = this.payoutData.scope.societies.ids
      return societyIds.map(id => {
        const match = this.memberCollectiveOptions.find(option => option.value === id)
        return {
          name: match.name,
          value: id,
        }
      })
    },

    generateCopyrightOptions () {
      const copyrightIds = this.payoutData.scope.copyrights.codes
      return copyrightIds.map(id => {
        const match = this.copyrightsOptions.find(option => option.value === id)
        return {
          name: match.name,
          value: id,
        }
      })
    },

    generateTariffOptions () {
      const distributionMap = this.payoutData.distributionsMap      
      return distributionMap && Object.entries(distributionMap).map(([key, value]) => ({
        id: key,
        name: value.description,
        value: value.description,
      }))
    },

    generateTariffOptionsOnCollegeChange (college) {
      const distributionMap = this.payoutData.distributionsMap      
      return distributionMap && Object.entries(distributionMap).filter(([, value]) => value.college === college).map(([key, value]) => ({
        id: key,
        name: value.description,
        value: value.description,
      }))
    },

    findTariffOptions (query) {
      if (query) {   
        let copyrightFilterForTariffs = []
        if (!this.selectedCopyrights.except) {
          copyrightFilterForTariffs = this.selectedCopyrights.values.map((c) => c.value)
        } else if (this.selectedCopyrights.except) {
          const selectedValues = this.selectedCopyrights.values.map((item) => item.value)
          copyrightFilterForTariffs = this.copyrightsOptions.map(o => o.value).filter((item) => !selectedValues.includes(item))
        }
        this.isLoading = true
        let college = this.payoutData.scope.college
        let college_filter_value = [distributionCollegeTypes.MAKER_AND_PERFORMER]
        let moratorium_filter = {}
        if (college === distributionCollegeTypes.MAKER) {
          college_filter_value.push(distributionCollegeTypes.MAKER)
          moratorium_filter.moratorium_active__maker__eq = false
        } else if (college === distributionCollegeTypes.PERFORMER) {
          college_filter_value.push(distributionCollegeTypes.PERFORMER)
          moratorium_filter.moratorium_active__performer__eq = false
        } else {
          college_filter_value.push(distributionCollegeTypes.MAKER, distributionCollegeTypes.PERFORMER)
          moratorium_filter.moratorium_active__maker__eq = false
          moratorium_filter.moratorium_active__performer__eq = false
        }
        let distributionQuery = {
          "description": query,
          "college": college_filter_value,
          "copyright": copyrightFilterForTariffs,
          ...moratorium_filter,
        }
        this.$api.distributions.distributionsList(distributionQuery).then(result => {
          this.tariffPeriodOptions = result.data.results
            .map(r => {
              return {
                "name": r["description"],
                "value": r["description"],
                "id": r.id,
                "resoundId": r.resoundId,
                "warning": this.isBelowMoratorium(r),
              }
            })
          this.isLoading = false
        })
      }
    },
    copyrightsRule () {
      if (this.selectedSociety.except === "all")
        return ""
      else if (this.selectedCopyrights.except !=="all")
        return "required"
      else
        return ""
    },
    getPlaceholder (key) {
      if (this[key]?.except === "all")
        return ""
      return this[key]?.except ? this.$t("except_placeholder") : this.$t("include_placeholder")
    },
    handleUpdateError (response) {
      const { data, status } = response
      let message = ""
      if (status === 400) {
        this.error(capitalize(this.$t("form_contains_errors")))
        this.$refs.scopeForm.setErrors(data)
      } else if (status === 422) {
        message = "Failed to update payout. Please correct the data and try again."
        if (data.nonFieldErrors) {
          message = message + "\n" + data.nonFieldErrors.map(e => e.message).join("\n")
        }
      } else {
        message = "Failed to update payout. Please contact administrator or try again."
      }
      this.error(message)
    },
    handleUpdateSuccess (response) {
      this.$emit("update-payout-data", response.data.results)
      this.$emit("change-payout-mode", payoutModes.VIEW)
      this.success(capitalize(this.$t("saved_changes")))
    },
    async updateScope (preview) {
      let data = {
        scope: {
          college: this.payoutData.scope.college,
          minThreshold: Number(this.payoutData.scope.minThreshold),
          distributions: {
            ids: this.selectedDistribution.values.map(t => t.id),
            select: this.selectedDistribution.except === true
              ? "exclude"
              : this.selectedDistribution.except === false
                ? "include"
                : "all",
          },
          societies: {
            ids: this.selectedSociety.values.map(t => t.value),
            select: this.selectedSociety.except === true
              ? "exclude"
              : this.selectedSociety.except === false
                ? "include"
                : "all",
          },
          copyrights: {
            codes: this.selectedCopyrights.values.map(t => t.value),
            select: this.selectedCopyrights.except === true
              ? "exclude"
              : this.selectedCopyrights.except === false
                ? "include"
                : "all",
          },
          includeCloseoutTransactions: this.payoutData.scope.includeCloseoutTransactions,
        }
      }
      try {
        let resp = await this.$api.payouts.updatePayout(this.payoutData.id, data, { "preview": preview })
        return { "response": resp, "success": true }
      } catch (e) {
        return { "response": e.response, "success": false }
      }
    },
    async onSubmit (preview = true) {
      this.scopeMessage = null
      let { response, success } = await this.updateScope(preview)
      if (!success) {
        this.handleUpdateError(response)
        return
      }
      if (!preview) {
        this.handleUpdateSuccess(response)
        return
      }
      if (response.data.message) {
        this.scopeMessage = response.data.message
        this.$bvModal.show("confirmation-modal")
      } else {
        let { response, success } = await this.updateScope(false)
        if (success) {
          this.handleUpdateSuccess(response)
        } else {
          this.handleUpdateError(response)
        }
      }
    },

    getSelectValue (value) {
      switch (value) {
      case "exclude": return true
      case "include": return false
      case "all": return "all"
      }
    }
  },
  watch: {
    "selectedSociety.except" (newVal) {
      if (newVal === "all") {
        this.selectedSociety.values = []
        this.selectedCopyrights.values = []
      }
    },
    "selectedDistribution.except" (newVal) {
      if (newVal === "all") {
        this.selectedDistribution.values = []
      }
    },
    "selectedCopyrights.except" (newVal) {
      if (newVal === "all") {
        this.selectedCopyrights.values = []
      }
    },
    "payoutData.scope.college" (newVal, oldVal) {
      if ((newVal === "performer" && oldVal === "maker") || (newVal === "maker" && oldVal === "performer")) {
        this.selectedDistribution.values = []
      } else if (newVal === "maker_and_performer") {
        this.selectedDistribution.values = this.generateTariffOptions()
      } else if ((newVal === "maker" || newVal === "performer")) {
        this.selectedDistribution.values = this.generateTariffOptionsOnCollegeChange(newVal)
      }
    }
  },
  mounted () {
    if (!this.copyrights.length) {
      this.getCopyrights()
    }
    if (!this.tariffs.length) {
      this.getTariffs()
    }
    if (this.payoutData.status === payoutStatuses.NOT_STARTED) {
      this.payoutMode = payoutModes.CREATE
    }
  },
}
</script>

<style lang="css" scoped>

.custom-select-search {
  .input-group-append {
    width: stretch;
    column-gap: 20px;
    .custom-select {
      border-radius: 0.25rem;
      background-color: white;
    }
    .select-search-input {
      padding: 0;
    }
    ::v-deep .input-group {
      padding-right: 20px;
    }
    ::v-deep .form-control[readonly] {
      background-color: transparent;
    }
    ::v-deep .form-control[disabled] {
      background-color: transparent;
      opacity: 0.6;
      cursor: not-allowed;
      pointer-events: all;
    }
  }
}

.include-exclude-append {
  width: stretch;
  .input-group-append {
    width: stretch;
    .includeExcludeSelector {
      width: stretch;
      column-gap: 20px;
    }
    ::v-deep .custom-select {
      border-radius: 0.25rem;
      background-color: white;
    }
  }
}

::v-deep .multiselect--disabled {
  cursor: not-allowed;
  pointer-events: all;
}

::v-deep .multiselect--disabled .multiselect__select {
    background-color: white !important;
    cursor: not-allowed;
  }

.view-values {
  .select {
    width: 10%;
  }
  .values {
    width: 90%;
  }
}
.edit-svg {
  height: 32px;
}
</style>